import { gql } from 'urql'

export const FragBookmarkedItemsPageSection = gql`
  fragment BookmarkedItemsPageSection on BookmarkedItemsPageSection {
    __typename
    title
    items {
      ... on VodClassCard {
        __typename
        id
        title
        slug
        imageUrl
        guideId
        guideName
        guideAvatarUrl
        durationSeconds
      }
      ... on ArticleCard {
        __typename
        id
        title
        slug
        imageUrl
        guideId
        guideName
        guideAvatarUrl
        readTimeInSeconds
      }
    }
  }
`
